import { __exports as symbols } from "../../../../../../_virtual/symbols.js";
var hasRequiredSymbols;
function requireSymbols() {
  if (hasRequiredSymbols) return symbols;
  hasRequiredSymbols = 1;
  symbols.isClean = /* @__PURE__ */ Symbol("isClean");
  symbols.my = /* @__PURE__ */ Symbol("my");
  return symbols;
}
export {
  requireSymbols as __require
};
//# sourceMappingURL=symbols.js.map
